(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fee-backorder-notice')) {
    customElements.define(
      'fee-backorder-notice',
      class FeeBackorderNotice extends HTMLElement {
        connectedCallback() {
          this.quantityInput = this.closest('product-info')?.querySelector('.quantity__input');
          this.handleQuantityChange = this.updateNotice.bind(this);
          this.quantityInput?.addEventListener('input', this.handleQuantityChange);
          this.quantityInput?.addEventListener('change', this.handleQuantityChange);
          this.quantityObserver = new MutationObserver(this.handleQuantityChange);
          if (this.quantityInput) {
            this.quantityObserver.observe(this.quantityInput, {
              attributes: true,
              attributeFilter: ['data-cart-quantity'],
            });
          }
          this.updateNotice();
        }

        disconnectedCallback() {
          this.quantityInput?.removeEventListener('input', this.handleQuantityChange);
          this.quantityInput?.removeEventListener('change', this.handleQuantityChange);
          this.quantityObserver?.disconnect();
        }

        updateNotice() {
          const inventoryIsTracked = this.dataset.inventoryTracked === 'true';
          const inventoryQuantity = Math.max(0, Number(this.dataset.inventoryQuantity));
          const cartQuantity = Math.max(0, Number(this.quantityInput?.dataset.cartQuantity || 0));
          const requestedQuantity = Math.max(1, Number(this.quantityInput?.value || 1));
          const remainingInventory = Math.max(0, inventoryQuantity - cartQuantity);
          const inStockQuantity = Math.min(requestedQuantity, remainingInventory);
          const backorderQuantity = Math.max(0, requestedQuantity - inStockQuantity);
          const isFullBackorder = inventoryIsTracked && backorderQuantity > 0 && inStockQuantity === 0;
          const isPartialBackorder = inventoryIsTracked && backorderQuantity > 0 && inStockQuantity > 0;
          const color = this.dataset.color;

          this.hidden = !isFullBackorder && !isPartialBackorder;
          this.querySelector('[data-in-stock-row]').hidden = inStockQuantity === 0;
          this.querySelector('[data-backorder-row]').hidden = backorderQuantity === 0;
          this.querySelector('[data-in-stock-color]').textContent = color;
          this.querySelector('[data-backorder-color]').textContent = color;
          this.querySelector('[data-in-stock-count]').textContent = inStockQuantity;
          this.querySelector('[data-backorder-count]').textContent = backorderQuantity;
          this.querySelector('[data-full-backorder]').hidden = !isFullBackorder;
          this.querySelector('[data-partial-backorder]').hidden = !isPartialBackorder;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
